import { motion } from "framer-motion";
import { CalendarHeart, MapPinned, Mic2 } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: CalendarHeart,
    title: "Le rendez-vous",
    text: "Samedi 10 octobre, les portes ouvrent à 18h30 et la masterclass débute à 19h précises. Une soirée entièrement gratuite, pensée pour tous les pianistes.",
  },
  {
    num: "02",
    icon: MapPinned,
    title: "Le lieu",
    text: "81 Tollaan, 1200 Woluwe-Saint-Lambert — au cœur de Bruxelles, dans un cadre chaleureux propice à la musique et à la rencontre.",
  },
  {
    num: "03",
    icon: Mic2,
    title: "L'expérience",
    text: "Accords gospel, accompagnement et improvisation : enrichissez votre jeu au piano avec la pédagogie du Conservatoire de la Musique Chrétienne, quel que soit votre niveau.",
  },
];

export default function Programme() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-28" data-testid="programme-section">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="uppercase tracking-[0.25em] text-xs font-bold text-[#D95D39] mb-4"
      >
        La soirée en trois chapitres
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#2C1E16] max-w-3xl"
      >
        Enrichissez votre <span className="italic text-[#D95D39]">jeu au piano</span>.
      </motion.h2>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.num}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            data-testid={`chapter-${c.num}`}
            className={`md:col-span-4 border-t-2 border-[#2C1E16] pt-6 ${i === 1 ? "md:mt-12" : ""} ${i === 2 ? "md:mt-24" : ""}`}
          >
            <div className="flex items-baseline justify-between">
              <span className="font-display italic text-5xl text-[#D95D39]/40">{c.num}</span>
              <c.icon className="w-6 h-6 text-[#D95D39]" />
            </div>
            <h3 className="mt-4 font-display font-bold text-2xl text-[#2C1E16] tracking-tight">{c.title}</h3>
            <p className="mt-3 text-[#5C4A3D] text-base leading-relaxed">{c.text}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
